var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        "xml:space": "preserve",
        fill: "currentColor",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "m67.6 88.5 351.6 351.6 31.1-31.1L98.7 57.4 67.6 88.5zm395.6 144.7-116 116 31.1 31.1 116-116-31.1-31.1zM309.4 387 294 402.4l-28.5 28.5c-27.1 26.9-55.1 36.9-82.1 37-31.1.1-61.8-14.2-84.6-37-22.8-22.8-37.1-53.5-37-84.6.1-27 10.1-55 37-82.1l44-44-31.1-31.1-44 44c-34.3 34.2-50.1 74.6-49.9 113.2.1 44.5 19.8 85.6 49.9 115.7 30.1 30.1 71.2 49.9 115.7 49.9 38.6.1 79-15.6 113.2-49.9l44-44-31.2-31zM186.6 176.4 296.5 66.5C313.4 49.8 330 44.1 346.1 44c18.5-.1 37.2 8.5 51.2 22.6 14 14 22.6 32.8 22.6 51.2-.1 16.1-5.8 32.6-22.6 49.6l-7.8 7.8 7.8-7.8C353 211.5 287.4 277.2 287.4 277.2l31.1 31.1s65.6-65.7 109.9-109.9c24.1-23.9 35.6-53 35.4-80.6-.1-31.9-14.2-61-35.4-82.3C407.1 14.2 378 .1 346.1 0c-27.6-.1-56.7 11.3-80.6 35.4l-78.3 78.3-31.5 31.5 30.9 31.2zm56.8 144.7-44 44c-6.7 6.5-11.9 7.9-17 8.1-5.9.1-12.7-2.9-17.8-8.1-5.2-5.2-8.1-12-8.1-17.8.1-5.2 1.5-10.3 8.1-17l3.1-3.1-3.1 3.1 44-44-31.1-31.1-44 44c-13.9 13.7-21.1 31.4-20.9 48.1.1 19.3 8.5 36.5 20.9 48.9 12.5 12.4 29.6 20.9 48.9 20.9 16.7.1 34.4-7 48.1-20.9l44-44-31.1-31.1zm-21.9-109.9-.2.2c-4.2 4.1-6.4 9.7-6.4 15.5 0 5.9 2.3 11.4 6.4 15.5 4.1 4.2 9.7 6.4 15.5 6.4 5.9 0 11.4-2.3 15.5-6.4l110.1-110.1-31.1-31.1-55 55-55 55c-8.6 8.6-8.6 22.5 0 31.1s22.5 8.6 31.1 0l.2-.2-31.1-30.9z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }